import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { AttioObjectDataset } from 'app/model/dataset/attio.dataset';
import { AttioLinkedService } from 'app/model/linkedservice/attio.linkedservice';
import { GlobalVariables } from 'app/services/globals';
import { format } from 'app/shared/utils/string.util';

export const attioObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(AttioObjectDataset).name,
    disabled: !GlobalVariables.enableAttioConnector,
    displayName: 'Attio',
    supportLinkedServiceTypes: [Metamodel.modelFor(AttioLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-REST'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    schemaAlias: 'schema',
    tableAlias: 'table',
    schemaNameDisplay: stringResources.Schema,
    tableNameDisplay: stringResources.ModelName_Table,
    isTableRequired: true,
    notSupportCopySourceQuery: true,
    notSupportPhysicalType: true,
    category: ['ServicesApps'],
    copySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'pageSize',
                label: stringResources.PageSizeLabel,
                defaultValue: 50,
                inputType: 'number',
                min: 1,
                dataType: 'integer',
                validators: [
                    {
                        type: 'number',
                        min: 1,
                        errorMessage: format(
                            stringResources.Above0ErrorMessage,
                            stringResources.PageSizeLabel
                        )
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ]
};
